import React from 'react';
import { Box } from '@material-ui/core';
import ByQuestionModuleTypeChart from 'components/ReportsModule/components/KeyboardingReport/Classroom/charts/ByQuestionModuleTypeChart';
import { useTranslation } from 'react-i18next';
import {
  KeyClassroomEngagementAssessmentAcceleratorResult,
  KeyStudentEngagementAssessmentAcceleratorResult
} from 'types/schema-generated-types';
import {
  buildModuleLabels,
  buildModuleSeries
} from 'components/ReportsModule/components/KeyboardingReport/keyboarding-report-util';

type Props = {
  reportData?:
    | KeyStudentEngagementAssessmentAcceleratorResult
    | KeyClassroomEngagementAssessmentAcceleratorResult;
  selectedModule?: string;
};

const AllModuleAssessmentCharts = ({ reportData, selectedModule }: Props) => {
  const { t } = useTranslation('Reports');

  return (
    <>
      <Box marginBottom={4}>
        <ByQuestionModuleTypeChart
          title="Average Time Spent per Question Type"
          helpText={t('timeToCompleteQuestionHelp', { ns: 'ReportsHelpCards' })}
          yAxisText={t('Avg. Time Spent per Question (seconds)')}
          labels={buildModuleLabels(reportData)}
          {...buildModuleSeries(reportData!, 'averageSecondsSpent')}
        />
      </Box>
      <Box>
        <ByQuestionModuleTypeChart
          title="Average Number of Tries"
          helpText={t('numberOfTriesQuestionHelp', { ns: 'ReportsHelpCards' })}
          yAxisText={t('Avg. No. of Tries')}
          labels={buildModuleLabels(reportData)}
          {...buildModuleSeries(reportData!, 'averageAttemptCount')}
        />
      </Box>

      {/* <DownloadListCard
        onClick={openConstructAResponse}
        title="View Question Results"
        Icon={GetAppIcon}
        data={downloadData as any}
        xs={12}
      /> */}
    </>
  );
};

export default AllModuleAssessmentCharts;
